import React, { Fragment, useState, useEffect } from "react";
import { Button, Dropdown, Modal, Badge } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";
//** Import Image */
import PageTitle from "../container/layouts/PageTitle";
import axios from "axios";
import { Progress } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import profile05 from "../images/profile/5.jpg";
import { getInstance } from '../config/token';
import Spinner from 'react-bootstrap/Spinner'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import $ from 'jquery';
import linkifyHtml from 'linkifyjs/html'
import dateFormat from "dateformat";
const TicketDetail = (props) => {
  const history = useHistory()
  const [activeToggle, setActiveToggle] = useState("posts");
  const [sendMessage, setSendMessage] = useState(false);
  const [postModal, setPostModal] = useState(false);
  const [cameraModal, setCameraModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [ticketDetail, setTicketDetail] = useState([]);
  const [message, setmessage] = useState("");
  const [file, setFile] = useState("");

  const [loaded, setLoader] = useState(0);
  const [fileName, setFileName] = useState([]);
  // const [fileLabel, setFileLabel] = useState("");
  const [filePath, setFilePath] = useState([]);
  const[modalStatus, setModalStatus] = useState(false)
  const[statusTicktId, setStatusTicktId] = useState("")
  const[statusTicktType, setStatusTicktType] = useState("")
  const [loadingStatus, setLoadingStatus] = useState(false);
  const[status, setStatus] = useState("")
  const[messageLoading, setMessageLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const [replay, setReplay] = useState(false);
  const prefix = process.env.REACT_APP_API_URL;
  

  useEffect(() => {
    // window.scrollTo(0, 0);
    // window.scrollTo(0, document.body.scrollHeight);
    getTicketDetails();
  }, []);

  $('body').on('click', 'a', function(e) {
    e.target.target = '_blank';
  });

 
  const goToPage = (page) =>{
     if(page == 'sms'){
        history.push("/sms-list");
     }
     if(page == 'ticket'){
        history.push("/ticket-list");
     }
     setShowPopup(false)
  }

  const getTicketDetails = () => {
    let path = window.location.pathname.split("/");
    let ticketId = path[path.length - 1].split("-");

    setLoading(true);
    let config = getInstance('GET', `/api/get_ticket_detail/`+ ticketId);
    axios(config).then((res) => {
      console.log(res.data);
      let tktMsg = res.data[0].user_ticket_messages
      for(let i = 0; i < tktMsg.length; i++){
        // var count = (res.data[0].user_ticket_messages[i].message.match(/src=\"cid:/g) || []).length;
        // var div = document.createElement('div');
        // div.innerHTML =  res.data[0].user_ticket_messages[i].message;
        if(tktMsg[i].user_ticket_message_files && tktMsg[i].user_ticket_message_files.length > 0){
        let tktMsgFile = tktMsg[i].user_ticket_message_files
        for(let j = 0; j < tktMsgFile.length; j++){
          if(tktMsgFile[j].google_attachment_id){
            res.data[0].user_ticket_messages[i].message = tktMsg[i].message.replace("cid:"+tktMsgFile[j].google_attachment_id, tktMsgFile[j].file);
          }
          // let image =div.getElementsByTagName('img')[i]
          // var imgSrc = image ? image.src : "";
          // alert(imgSrc)
        }
      }
      }
      
      setTicketDetail(res.data);
      setLoading(false);
      window.scrollTo(0, document.body.scrollHeight);
    });
  };

  const showReplayModal = () => {
    setReplay(true);
    setFileName([])
  };

  const createMessage = () => {
    setMessageLoading(true)
    let path1 = window.location.pathname.split("/");
    let ticketId1 = parseInt(path1[path1.length - 1]);
    // setErrMsg("")
    let errFlag = false;
    if (message == "") {
      errFlag = true;
      toast.error("Message is required.", {
        position: "top-right",
      });
    } else if (message.length > 20000) {
      errFlag = true;
      toast.error("Message can not be more than 20000 characters.", {
        position: "top-right",
      });
    }

    if (!errFlag) {
      let requestObj = {
        message: message,
        file: filePath,
        ticketId: ticketId1,
      };
      let config = getInstance('POST', `/api/create_message`, requestObj);
      axios(config).then((res) => {
        setFileName([]);
        setmessage("");
        setFile("");
        setFilePath([])

        // getTicketDetails();
        props.history.push("/ticket-list");

        toast.success("Success", {
          position: "top-right",
        });
        setReplay(false);
        setMessageLoading(false)
      });
    } else {
      setMessageLoading(false)
    }
    // else {
    //   toast.error(errMsg, {
    //     position: "top-right",
    //   });
    // }
  };

  const maxSelectFile = (event) => {
    let files = event.target.files; // create file object
    if (files.length > 3) {
      //  const msg = 'Only 3 images can be uploaded at a time'
      event.target.value = null; // discard selected file
      toast.error("Only 2 files can be uploaded at a time.", {
        position: "top-right",
      });
      return false;
    }
    return true;
  };

  const checkFileSize = (event) => {
    let files = event.target.files;
    let size = 5000000;
    let err = "";
    for (var x = 0; x < files.length; x++) {
      if (files[x].size > size) {
        err += files[x].type + " is too large, please pick a smaller file\n";
      }
    }
    if (err !== "") {
      event.target.value = null;
      toast.error(err, {
        position: "top-right",
      });
      return false;
    }

    return true;
  };

  const onFileChange = (e) => {
    setMessageLoading(true)
    // this.setState({ file: e.target.files[0] },() => {
    var mulFiles = e.target.files;
    if (maxSelectFile(e) && checkFileSize(e)) {
      // setLoading(true);
      setFile(mulFiles);
      const data = new FormData();
      for (var x = 0; x < mulFiles.length; x++) {
        data.append("file", mulFiles[x]);
      }
      // data.append("file", e.target.files[0]);
      let config = getInstance('POST', `/api/upload`, data);

      axios.post(config.url, config.data,  {
        headers: config.headers,
        onUploadProgress: (ProgressEvent) => {
          setLoader((ProgressEvent.loaded / ProgressEvent.total) * 100);
        },
      })
      // axios(config, {
      //   onUploadProgress: (ProgressEvent) => {
      //     setLoader((ProgressEvent.loaded / ProgressEvent.total) * 100);
      //   },
      // })
        // .post(prefix + "/api/upload", data, {
        //   onUploadProgress: (ProgressEvent) => {
        //     setLoader((ProgressEvent.loaded / ProgressEvent.total) * 100);
        //   },
        // })

        .then((res) => {
          // then print response status
          setLoader(0);
          // setCameraModal(false);
          let filePathArray = filePath
          let fName = fileName
          for (let i = 0; i < res.data.length; i++) {
            // setFileName(res.data[i] && res.data[i].filename ? res.data[isNaN].filename : "");
            let filepath = prefix + "/" + res.data[i].path;
            filePathArray.push(filepath);
            // setFilePath(filepath)
            fName.push(res.data[i].filename)
          }
          setFilePath(filePathArray);
          setFileName(fName)
          setMessageLoading(false)
          // setLoading(false);
        })
        .catch((err) => {
          setMessageLoading(false)
        })
    } else {
      setMessageLoading(false)
    }
  };

  const options = {
    settings: {
      overlayColor: "#000000",
    },
  };

  const openStatusModal = (ticketId, statusType) => {
    if(localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2){
      setModalStatus(true)
      setStatusTicktId(ticketId)
      setStatusTicktType(statusType)
    }
  }

  const onStatusChange = (e, ticketIds) => {
    setStatus(e.target.value)
  }

  const changeStatus = (type, ticketIds) => {
    setLoadingStatus(true)
    let requestObj = {
      status: type,
      ticketIds: ticketIds,
    };
    let config = getInstance('POST', `/api/update_ticket_status`, requestObj);
    axios(config)
      // .post(prefix + "/api/create_ticket", requestObj)
      .then((res) => {
        setLoadingStatus(false)
        toast.success("Ticket status changed", {
          position: "top-right",
        });
        setStatusTicktId("")
        setStatusTicktType("")
        setModalStatus(false)
        props.history.push("/ticket-list");
      })
      .catch((err) => {
        let message = "Something went wrong!"
        setLoadingStatus(false)
        if(err.response && err.response.data && err.response.data.message){
          message = err.response.data.message
        }
        toast.error(message, {
          position: "top-right",
        });
        console.log(err)
      });
  }

  return (
    <Fragment>
      {/* <PageTitle activeMenu="Profile" motherMenu="App" /> */}
      {/* <h4>Ticket title will be this.</h4> */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Modal
          show={modalStatus}
          // onHide={() => this.setState({ cameraModal: false })}
          className="modal fade"
          id="statusModal"
        >
        <div className="">
            <div className="modal-header">
              <h5 className="modal-title">Update Status - BGTKT{statusTicktId}</h5>
              <Button
                variant=""
                type="button"
                className="close"
                data-dismiss="modal"
                onClick={() => setModalStatus(false)}
              >
                <span>×</span>
              </Button>
            </div>
            <div className="modal-body">
              <form
                className="comment-form"
                onSubmit={(e) => {
                  e.preventDefault();
                  // setNewEvent(false);
                }}
              >
                <div>
                  <div className="form-group">
                    <div className="form-group">
                      <label className="text-black font-w500">
                        Select Type
                      </label>
                      <select
                        className="form-control form-border-color"
                        // style={{ width: "fit-content" }}
                        name="type"
                        id="type"
                        defaultValue={statusTicktType}
                        onChange={(e) => onStatusChange(e)}
                      >
                        <option value="0">Open</option>
                        <option value="1">Completed</option>
                        <option value="2">Pending</option>
                        <option value="3">Spam</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-group" style={{ textAlign: "center" }}>
                    <input
                      disabled={loadingStatus}
                      type="submit"
                      value="Update Status"
                      className="btn btn-primary"
                      onClick={() => changeStatus(status, [statusTicktId])}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Modal>
        <Modal className="modal fade" show={showPopup}>
            <div className="">
              <div className="modal-header" style={{backgroundColor : "#FE634E"}}>
                <h5 className="modal-title">Go To:</h5>
                <Button
                  variant=""
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  onClick={() => setShowPopup(false)}
                >
                  <span>×</span>
                </Button>
              </div>
              <div className="modal-body" style={{textAlign : "center"}}>
                <form
                  className="comment-form"
                  onSubmit={(e) => {
                    e.preventDefault();
                    // this.setState({ newEvent: false });
                  }}
                >
                  <div>
                    <div className="form-group">
                      <div className="form-group">

                      <div onClick={() => goToPage("sms")}>
                        <strong style={{cursor : "pointer", color : "black"}}>BG SMS</strong>
                        <br/>
                        <br/>
                     </div>
                     <div onClick={() => goToPage("ticket")}>
                        <strong style={{cursor : "pointer", color : "black"}}>BG Help Desk</strong>
                        <br/>
                        <br/>
                     </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Modal>
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              {loading ? (
                <div
                  style={{
                    textAlign: "center",
                    width: "100%",
                    position: "absolute",
                    marginBottom: "10px",
                  }}
                >
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden"></span>
                  </Spinner>{" "}
                </div>
              ) : (
                <div>
                  <div className="post-details">
                    <div className="row">
                      <div className="col-xl-10 text-center">
                      <ul className="mb-4 post-meta d-flex flex-wrap text-black">
                          <li className="post-author mr-3">
                        {ticketDetail &&
                          ticketDetail[0] &&
                          ticketDetail[0].id
                            ?<React.Fragment> 
                            <span style={{cursor : "pointer"}} onClick={() => setShowPopup(true)}>Home - </span> 
                            <Link style={{cursor : "pointer", color: "black"}} to={"/ticket-list"}>
                            Ticket
                          </Link> 
                          <span>{" - BGTKT" + ticketDetail[0].id}</span>
                          </React.Fragment>
                            : ""}
                        </li></ul>
                        <h3 className="mb-2 text-black ticket-title-custom">
                          {ticketDetail &&
                          ticketDetail[0] &&
                          ticketDetail[0].title
                            ? ticketDetail[0].title
                            : ""}
                        </h3>

                        <ul className="mb-4 post-meta d-flex flex-wrap">
                          <li className="post-author mr-3"> {ticketDetail &&
                          ticketDetail[0] &&
                          ticketDetail[0].id
                            ? <strong style={{color : "black"}}>{"BGTKT" + ticketDetail[0].id}</strong>
                            : ""}</li>
                          <li className="post-date mr-3">
                            <i className="fa fa-calender" />
                            {ticketDetail &&
                            ticketDetail[0] &&
                            ticketDetail[0].createdAt
                              ? 
                              new Date(
                                ticketDetail[0].createdAt
                                ).toLocaleString('en-US', { timeZone: 'America/New_York' })
                              // dateFormat(new Date(ticketDetail[0].createdAt), "m/d/yyyy, h:M:s TT")
                              : ""}
                          </li>
                          <li className="post-comment"style={{marginRight : ticketDetail && ticketDetail[0] && ticketDetail[0].order_id ? "1rem" : ""}}>
                            {/* <i className="fa fa-comments-o" /> 28 */}
                            {ticketDetail &&
                            ticketDetail[0] &&
                            ticketDetail[0].order_id
                              ? "BGUSA" + ticketDetail[0].order_id
                              : ""}
                          </li>
                          <li className="post-comment"style={{marginRight : "0.3rem", fontWeight : "600"}}>
                            {/* <i className="fa fa-comments-o" /> 28 */}
                            {ticketDetail &&
                            ticketDetail[0] &&
                            ticketDetail[0].source &&
                            ticketDetail[0].source == "email"
                              ? ticketDetail[0].user_type == 3 ? "rent@babiesgetaway.com" : ticketDetail[0].user_type == 4 ? "support@babiesgetaway.com" : ""
                              : ""}
                          </li>
                        </ul>
                      </div>
                      <div className="col-xl-2">
                      <div style={{marginBottom : "0.5rem"}}>
                          {ticketDetail && ticketDetail[0] && ticketDetail[0].id ? 
                        <Badge variant="success light" style = {{cursor : "pointer"}} className={ticketDetail[0].status == 0 ?"status-open" : ticketDetail[0].status == 1 ? "status-closed" : "status-pending"}>
                          {ticketDetail[0].status == 0
                            ? 
                            <span onClick={() => openStatusModal(ticketDetail[0].id, 0)}>
                                Open
                              </span>
                            : ticketDetail[0].status == 1? 
                            <span onClick={() => openStatusModal(ticketDetail[0].id, 1)}>
                              Completed
                            </span>
                            : ticketDetail[0].status == 2? 
                            <span onClick={() => openStatusModal(ticketDetail[0].id, 2)}>
                            Pending
                            </span>
                            : ticketDetail[0].status == 3 ? <span onClick={() => openStatusModal(ticketDetail[0].id, 3)}>
                            Spam
                            </span> : ""
                          }
                        </Badge> : ""}
                        </div>
                        <button
                          className="btn btn-secondary"
                          onClick={() => showReplayModal()}
                        >
                          <span className="mr-2">
                            <i className="fa fa-reply" />
                          </span>
                          Reply
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="profile-tab">
                    <div className="custom-tab-1">
                      <div className="tab-content">
                        <div
                          id="my-posts"
                          className={`tab-pane fade ${
                            activeToggle === "posts" ? "active show" : ""
                          }`}
                        >
                          {/* <Modal
                        className="modal fade show"
                        id="replyModal"
                        style={{ display: "block", paddingRight: 15 }}
                        aria-modal="true"
                        show={replay}
                      > */}
                          <Modal
                          disabled = {messageLoading}
                          enforceFocus={false}
                            show={replay}
                            // onHide={() => this.setState({ cameraModal: false })}
                            className="modal fade"
                            id="replay"
                          >
                            <div className="modal-header">
                              <h5 className="modal-title">Post Reply</h5>
                              <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                onClick={() => setReplay(false)}
                              >
                                <span>×</span>
                              </button>
                            </div>
                            <div className="modal-body">
                              <form
                              // onSubmit={(e) => {
                              //   e.preventDefault();
                              //   setReplay(false);
                              // }}
                              >
                                <label className="text-black font-w500">
                                  Message
                                </label>
                                {/* <textarea
                                  name="message"
                                  id="textarea"
                                  cols={30}
                                  rows={5}
                                  maxLength={1500}
                                  className="form-control bg-transparent"
                                  placeholder="Please enter ticket message"
                                  defaultValue={""}
                                  required
                                  spellcheck="true"
                                  onChange={(e) => setmessage(e.target.value)}
                                /> */}
                                <ReactQuill theme="snow" value={message} onChange={setmessage} />
                                <div className="modal-body">
                                  <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                      <span className="input-group-text">
                                        Upload
                                      </span>
                                    </div>
                                    <div className="custom-file">
                                      <input
                                        type="file"
                                        name="file"
                                        multiple
                                        className="custom-file-input"
                                        onChange={(e) => onFileChange(e)}
                                      />
                                      <label className="custom-file-label form-border-color">
                                        Choose file
                                      </label>
                                    </div>
                                  </div>
                                  <div class="form-group ">
                                    <Progress
                                      max="100"
                                      color="success"
                                      value={loaded}
                                    >
                                      {Math.round(loaded, 2)}%
                                    </Progress>
                                  </div>
                                  {fileName.map(function (name, j) {
                                    return (
                                      <div>
                                        {name}
                                        <br />
                                      </div>
                                    );
                                  })}
                                </div>
                              </form>
                            </div>
                            <div className="modal-footer">
                              {/* <button
                            type="button"
                            className="btn btn-danger light"
                            data-dismiss="modal"
                            onClick={() => setReplay(false)}
                          >
                            Close
                          </button> */}
                              <button
                                disabled = {messageLoading}
                                type="button"
                                className="btn btn-primary"
                                onClick={() => createMessage()}
                              >
                                Reply
                              </button>
                            </div>
                          </Modal>
                          <div className="my-post-content pt-3">
                            {ticketDetail.length &&
                              ticketDetail[0] &&
                              ticketDetail[0].user_ticket_messages &&
                              ticketDetail[0].user_ticket_messages.map(
                                function (item, i) {
                                  return (
                                    <div className="profile-uoloaded-post border-bottom-1 pb-5">
                                      <div className="media pt-3 pb-3">
                                        <img
                                          src={
                                            item.user &&
                                            item.user.profile_picture
                                              ? process.env
                                                  .REACT_APP_IMAGE_URL +
                                                item.user.profile_picture
                                              : profile05
                                          }
                                          alt=""
                                          className="mr-3 rounded"
                                          width={75}
                                        />
                                        <div className="media-body" style={{overflow : "auto", marginTop : localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2 ? "" : "15px"}}>
                                          <h5 className="m-b-5">
                                            {item.user
                                              ? item.user.first_name &&
                                                item.user.last_name
                                                ? item.user.first_name +
                                                  " " +
                                                  item.user.last_name
                                                : item.user.first_name
                                                ? item.user.first_name
                                                : item.user.last_name
                                                ? item.user.last_name
                                                : "-"
                                              : "-"}
                                              
                                          </h5>
                                          <h5>{localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2 ? 
                                                item.user && item.user.email ? "" + item.user.email : ""
                                                : ""
                                              }</h5>
                                            <h5>{
                                              new Date(
                                                item.createdAt
                                              ).toLocaleString('en-US', { timeZone: 'America/New_York' })
                                              // dateFormat(new Date(item.createdAt), "m/d/yyyy, h:M:s TT")
                                            
                                          }</h5>
                                          <h5>{(localStorage.getItem("userType") == 1 || localStorage.getItem("userType") == 2) && item.is_email_read ?
                                          <Badge variant="success light" className={"status-open"}>
                                            <span>
                                                Read at : {new Date(item.email_read_date).toLocaleString('en-US', { timeZone: 'America/New_York' })}
                                            </span>
                                            </Badge>
                                              :""
                                          }</h5>
                                          {ticketDetail[0].user_ticket_messages.length - 1 == i ?  
                                            <button
                                            className="btn btn-secondary"
                                            onClick={() => showReplayModal()}
                                          >
                                            <span className="mr-2">
                                              <i className="fa fa-reply" />
                                            </span>
                                            Reply
                                          </button> : ""}
                                          {/* <p className="mb-0">{item.message}</p> */}
                                          
                                          {/* <Linkify>{item.message}</Linkify> */}
                                        </div>
                                        
                                      </div>
                                      <div style={{overflow : "auto"}} dangerouslySetInnerHTML={{ __html: linkifyHtml(item.message) }} />
                                      <div style={{display : "inline-block", marginTop : "10px"}}>
                                      {item.user_ticket_message_files &&
                                        item.user_ticket_message_files.map(
                                          function (filePath, j) {
                                            return (
                                              <div style={{marginLeft : j == 0 ? "" : "5px", display : "inline-block"}}>
                                                <a
                                                className="btn btn-secondary"
                                                  href={filePath.file}
                                                  target="_blank"
                                                  style={{backgroundColor : "#FE634E", borderColor : "#FE634E"}}
                                                >
                                                  {"Attachment " + (j+1)}
                                                </a>
                                                <br />
                                                <br />
                                              </div>
                                            );
                                          }
                                        )}
                                        </div>
                                      <br />
                                      <br />

                                      {/* <button
                                  className="btn btn-secondary"
                                  onClick={() =>
                                    showReplayModal()
                                  }
                                >
                                  <span className="mr-2">
                                    <i className="fa fa-reply" />
                                  </span>
                                  Reply
                                </button> */}
                                    </div>
                                  );
                                }
                              )}
                          </div>
                          <div className="up-arrow-div" onClick={()=>window.scrollTo(0, 0)}><i class="gg-arrow-up"></i></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default TicketDetail;
